import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { findMaxKeyValue } from './AATree';
import { domIOSystem } from './domIOSystem';
import { listStateSystem } from './listStateSystem';
import { loggerSystem } from './loggerSystem';
import { scrollToIndexSystem } from './scrollToIndexSystem';
import { offsetOf, originalIndexFromItemIndex, sizeSystem } from './sizeSystem';
export var scrollIntoViewSystem = u.system(function (_a) {
    var _b = __read(_a, 3), _c = _b[0], sizes = _c.sizes, totalCount = _c.totalCount, _d = _b[1], scrollTop = _d.scrollTop, viewportHeight = _d.viewportHeight, headerHeight = _d.headerHeight, scrollingInProgress = _d.scrollingInProgress, scrollToIndex = _b[2].scrollToIndex;
    var scrollIntoView = u.stream();
    u.connect(u.pipe(scrollIntoView, u.withLatestFrom(sizes, viewportHeight, totalCount, headerHeight, scrollTop), u.map(function (_a) {
        var _b = __read(_a, 6), _c = _b[0], index = _c.index, _d = _c.behavior, behavior = _d === void 0 ? 'auto' : _d, done = _c.done, sizes = _b[1], viewportHeight = _b[2], totalCount = _b[3], headerHeight = _b[4], scrollTop = _b[5];
        var lastIndex = totalCount - 1;
        var location = null;
        index = originalIndexFromItemIndex(index, sizes);
        index = Math.max(0, index, Math.min(lastIndex, index));
        var itemTop = offsetOf(index, sizes.offsetTree) + headerHeight;
        if (itemTop < scrollTop) {
            location = { index: index, behavior: behavior, align: 'start' };
        }
        else {
            var itemBottom = itemTop + findMaxKeyValue(sizes.sizeTree, index)[1];
            if (itemBottom > scrollTop + viewportHeight) {
                location = { index: index, behavior: behavior, align: 'end' };
            }
        }
        if (location) {
            done &&
                u.handleNext(u.pipe(scrollingInProgress, u.skip(1), u.filter(function (value) { return value === false; })), done);
        }
        else {
            done && done();
        }
        return location;
    }), u.filter(function (value) { return value !== null; })), scrollToIndex);
    return {
        scrollIntoView: scrollIntoView,
    };
}, u.tup(sizeSystem, domIOSystem, scrollToIndexSystem, listStateSystem, loggerSystem), { singleton: true });
